.timeline {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  width: 100%;
  height: 14px;
  padding: 0 var(--spacing\/1, 8px);
}

.track {
  position: relative;
  flex: 1;
  /* Global border-box reset includes the borders in height:
     14px total - 2×4px transparent border = 6px visual track,
     with the borders extending the click/hover target to the 14px container */
  height: 14px;
  border: 4px solid transparent;
  border-left: none;
  border-right: none;
  /* Figma: rgba(101,104,113,0.75) unviewed track */
  background: rgba(101, 104, 113, 0.75);
  background-clip: padding-box;
  border-radius: var(--radius\/3xl, 360px);
  cursor: pointer;
  transition: height 0.15s;
}

.track:hover,
.track:focus-visible,
.track[data-seeking="true"] {
  height: 16px;
}

.track:hover .thumb,
.track:focus-visible .thumb,
.track[data-seeking="true"] .thumb {
  opacity: 1;
}

.played {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: var(--color\/text\/link-accent, #4f98ff);
  border-radius: var(--radius\/3xl, 360px);
  pointer-events: none;
}

/* Hover preview: white 50% segment from the knob to the cursor */
.preview {
  position: absolute;
  top: 0;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
  border-radius: var(--radius\/3xl, 360px);
  pointer-events: none;
}

.thumb {
  position: absolute;
  top: 50%;
  width: 16px;
  height: 16px;
  background: var(--color\/text\/text-primary, #fff);
  border-radius: var(--radius\/3xl, 360px);
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: opacity 0.15s;
  pointer-events: none;
}

.tooltip {
  position: absolute;
  bottom: 100%;
  transform: translateX(-50%);
  margin-bottom: 6px;
  padding: var(--spacing\/1, 8px) var(--spacing\/2, 16px);
  font-family: 'Open Sans', sans-serif;
  font-size: var(--font\/fontsize\/body-small, 14px);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  color: var(--color\/text\/text-primary, #fff);
  background: rgba(0, 0, 0, 0.9);
  border-radius: 4px;
  pointer-events: none;
  user-select: none;
}
